module.exports = __webpack_public_path__ + "img/servicioMotorizada.3a2c019b.jpg";